import config from 'scoreboard/components/config'
import i18n from 'scoreboard/components/i18n'
import constants from 'scoreboard/components/constants'
const { NUMBER, STABILIZE_NUMBER, SCORED_TEXT } = constants

function defaultThresholds(kpiValueType) {
	// the score halfway between the minimum and the maximum
	let middleScore = (config.maximumScore - config.minimumScore) / 2

	return number(kpiValueType, middleScore) ||
		stabilizeNumber(kpiValueType, middleScore) ||
		scoredText(kpiValueType) ||
		unscoredText()
}

function number(kpiValueType, middleScore) {
	if (kpiValueType != NUMBER) return

	return [ {
		score: config.minimumScore,
		label: i18n.get('scorecards.node.metric.threshold.worst')
	}, {
		score: middleScore,
		label: i18n.get('scorecards.node.metric.threshold.goal'),
		// this is what we read from the DOM, so match that so
		// prefillDefaultThresholds will work
		goal: 'true'
	}, {
		score: config.maximumScore,
		label: i18n.get('scorecards.node.metric.threshold.best')
	} ]
}

function stabilizeNumber(kpiValueType, middleScore) {
	if (kpiValueType != STABILIZE_NUMBER) return

	return [ {
		score: config.minimumScore,
		label: i18n.get('scorecards.node.metric.threshold.lowworst')
	}, {
		score: middleScore,
		label: i18n.get('scorecards.node.metric.threshold.lowtarget')
	}, {
		score: config.maximumScore,
		label: i18n.get('scorecards.node.metric.threshold.best')
	}, {
		score: middleScore,
		label: i18n.get('scorecards.node.metric.threshold.hightarget')
	}, {
		score: config.minimumScore,
		label: i18n.get('scorecards.node.metric.threshold.highworst')
	} ]
}

function scoredText(kpiValueType) {
	if (kpiValueType != SCORED_TEXT) return

	return [ {
		score: config.minimumScore
	}, {
		score: config.maximumScore,
		// this is what we read from the DOM, so match that so
		// prefillDefaultThresholds will work
		goal: 'true'
	} ]
}

function unscoredText() {
	// doesn't make much sense to have a custom text scoring type with only one
	// threshold. you wouldn't actually be measuring much in that case!
	return [ {}, {} ]
}

export default defaultThresholds

defaultThresholds.__filename__ = 'admin/scoring-types/default-thresholds.js'
